import cacheFirstResponder from '../impl/cacheFirst';
import oAuthTokenResponder from '../impl/cacheOAuth';
import fetchToCacheResponder from '../impl/fetchToCache';
import headerAppendResponder from '../impl/headerAppend';
import keepAliveResponder from '../impl/keepAlive';
import logDiagnosticsResponder from '../impl/logDiagnostics';
import preCacheResponder from '../impl/preCache';
import zipRelativePathResponder from '../impl/zipPathRelative';
import type { MESSAGE_INTERFACES } from '../interface/instantiator';

const InstantiateMap: MESSAGE_INTERFACES = {
    AddCacheFirst: cacheFirstResponder,
    AddHeader: headerAppendResponder,
    AddOAuthTokenCache: oAuthTokenResponder,
    AddPreCache: preCacheResponder,
    AddZipPathRelativeResponder: zipRelativePathResponder,
    AddKeepAliveMessageResponder: keepAliveResponder,
    LogDiagnostics: logDiagnosticsResponder,
    FetchToCache: fetchToCacheResponder,
};

export default Object.freeze({
    allInterfaces: <K extends keyof MESSAGE_INTERFACES>() => Object.keys(InstantiateMap) as K[],
    message: <K extends keyof MESSAGE_INTERFACES, V extends MESSAGE_INTERFACES[K]>(name: K) =>
        InstantiateMap[name] as V,
});
